import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/organization")({
  beforeLoad: () => {
    throw redirect({ to: "/projects" });
  },
});
